import React from 'react'
import { ChevronDown, ChevronUp, Pencil } from 'lucide-react'
import { tr } from 'i18n'
import { useTranslation as useInterfaceLanguage } from 'react-i18next'
import { Vehicle, StatusBadge } from 'components/Erp/Display'
import DriverStatus from 'components/Erp/DriverStatus/DriverStatus.tsx'
import { DriverSyncStatus } from 'components/Erp/IntegrationTrip'
import styles from '../AdminPanelPage.module.scss'
import list from './DriverBaseList.module.scss'

export default function BaseDriverSummary({ driver, expanded, editing, detailId, onToggle, onEdit }) {
  useInterfaceLanguage()
  const phone = driver.employee_phone || driver.phone
  return (
    <tr className={list.row} onClick={event => {
      if (event.target.closest('button, a, input, select, textarea, img')) return
      onToggle()
    }}>
      <td data-label={tr('Автомобиль')} className={list.vehicle}><Vehicle number={driver.vehicle_number} model={driver.vehicle_model} /></td>
      <td data-label={tr('Водитель')}>
        <div className={list.driverIdentity}>
          <strong>{tr(driver.employee_name || 'Без водителя')}</strong>
          <span className={list.muted}>{tr('ИНН')}: {driver.inn || '—'}</span>
          {phone && <a className={list.phone} href={`tel:${phone}`}>{phone}</a>}
        </div>
      </td>
      <td data-label={tr('Поездки')} className={list.trips}>{driver.loads_count ?? 0}</td>
      <td data-label={tr('Статус')}>
        <div className={list.status}>
          <DriverStatus driver={driver} />
          <StatusBadge tone={driver.is_active ? 'success' : 'neutral'}>{tr(driver.is_active ? 'Активен' : 'Не активен')}</StatusBadge>
        </div>
      </td>
      <td data-label={tr('Синхронизация')} className={list.sync}><DriverSyncStatus driver={driver} /></td>
      <td data-label={tr('Действия')}>
        <div className={`${styles.actionGroup} ${list.actions}`}>
          <button type="button" className={styles.smallBtn} aria-expanded={expanded} aria-controls={detailId} onClick={onToggle}>
            {expanded ? <ChevronUp size={14} aria-hidden="true" /> : <ChevronDown size={14} aria-hidden="true" />}{tr('Подробнее')}
          </button>
          {onEdit && <button type="button" className={`${styles.smallBtn} ${styles.editBtn}`} aria-expanded={editing} onClick={onEdit}>
            <Pencil size={14} aria-hidden="true" />{tr(' Изменить')}
          </button>}
        </div>
      </td>
    </tr>
  )
}
